import { esConceptoDeclaracionViatico } from './gratificacionPlame';

/**
 * Compara suma real de viáticos en tareos vs monto_viatico_standard × días asistidos.
 * @returns {null|{coincide,sinMontoEmpleado,montoDia,diasAsistidos,diasConViatico,totalReal,totalEsperado,diferencia,emoji,title}}
 */
export function evaluarCuadreViaticos({
  tareos = [],
  plameConfiguracionId,
  montoDia,
  fechaInicio,
  fechaFin,
  activo = true,
} = {}) {
  if (!activo) return null;
  if (!plameConfiguracionId && !(tareos || []).some((r) =>
    (r.conceptos || []).some((c) =>
      String(c.codigo || c.codigo_plame || c.codigoPlame || c.plame_configuracion?.codigo_plame || '').trim() === '0917'
      || esConceptoDeclaracionViatico(c)
    )
  )) {
    return null;
  }

  const plameViaticoId = Number(plameConfiguracionId) || 0;
  const monto = Number(montoDia) || 0;

  const enPeriodo = (fechaTareo) => {
    if (!fechaInicio || !fechaFin || !fechaTareo) return true;
    const f = String(fechaTareo).split('T')[0];
    const ini = String(fechaInicio).split('T')[0];
    const fin = String(fechaFin).split('T')[0];
    return f >= ini && f <= fin;
  };

  const tareosPeriodo = (tareos || []).filter((r) => enPeriodo(r.fecha));
  const esAsistencia = (r) => {
    const t = String(r.tipoEvento || r.tipo_evento || r.tipo || '').toLowerCase();
    return t === 'asistio' || t === 'asistió' || t === 'asistencia' || t === 'asistencia_completa';
  };
  const diasAsistidos = new Set(
    tareosPeriodo
      .filter(esAsistencia)
      .map((r) => String(r.fecha || '').split('T')[0])
      .filter(Boolean)
  ).size;

  const montoPorFecha = new Map();
  tareosPeriodo.forEach((r) => {
    const fechaKey = String(r.fecha || '').split('T')[0];
    (r.conceptos || []).forEach((c) => {
      const cid = Number(c.plame_configuracion_id || c.plame_configuracion?.id || 0);
      const codigo = String(
        c.codigo
        || c.codigo_plame
        || c.codigoPlame
        || c.plame_configuracion?.codigo_plame
        || ''
      ).trim();
      const esViatico = (cid > 0 && cid === plameViaticoId)
        || codigo === '0917'
        || esConceptoDeclaracionViatico(c);
      if (!esViatico) return;
      const m = parseFloat(c.monto ?? c.valor) || 0;
      if (m <= 0) return;
      const prev = montoPorFecha.get(fechaKey) || 0;
      if (m > prev) montoPorFecha.set(fechaKey, m);
    });
  });

  const totalReal = [...montoPorFecha.values()].reduce((s, m) => s + m, 0);
  const diasConViatico = montoPorFecha.size;
  const totalEsperado = monto > 0 ? Number((monto * diasAsistidos).toFixed(2)) : null;
  const diferencia = totalEsperado != null ? Number((totalReal - totalEsperado).toFixed(2)) : null;
  const coincide = totalEsperado != null && Math.abs(diferencia) < 0.01;
  const sinMontoEmpleado = !(monto > 0);

  if (totalReal <= 0 && !(monto > 0 && diasAsistidos > 0)) return null;

  let emoji = '🚕⚠️';
  let title = `Viáticos: real S/ ${totalReal.toFixed(2)} ≠ esperado`;
  if (sinMontoEmpleado) {
    emoji = '🚕❓';
    title = `Viáticos reales S/ ${totalReal.toFixed(2)} — sin monto_viatico_standard`;
  } else if (coincide) {
    emoji = '🚕✅';
    title = `Viáticos cuadran: S/ ${totalReal.toFixed(2)} = S/ ${monto.toFixed(2)} × ${diasAsistidos} días`;
  } else {
    title = `Viáticos: real S/ ${totalReal.toFixed(2)} vs esperado S/ ${totalEsperado.toFixed(2)} (S/ ${monto.toFixed(2)} × ${diasAsistidos}) · diff ${diferencia >= 0 ? '+' : ''}${diferencia.toFixed(2)}`;
  }

  return {
    montoDia: monto,
    diasAsistidos,
    diasConViatico,
    totalReal: Number(totalReal.toFixed(2)),
    totalEsperado,
    diferencia,
    coincide,
    sinMontoEmpleado,
    emoji,
    title,
  };
}

export function etiquetaCuadreViaticos(cuadre) {
  if (!cuadre) return '';
  const real = Number(cuadre.totalReal || 0).toFixed(2);
  if (cuadre.totalEsperado == null) {
    return `${cuadre.emoji} S/ ${real} vs —`;
  }
  return `${cuadre.emoji} S/ ${real} vs S/ ${Number(cuadre.totalEsperado).toFixed(2)}`;
}

export default evaluarCuadreViaticos;
